// @ts-nocheck
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  useMediaQuery,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";

import { Label, Radio, ToggleSwitch } from "flowbite-react";

import React, { useEffect, useRef, useState } from "react";

import {
  FaArrowRight,
  FaPlus,
  FaRegQuestionCircle,
  FaTrash,
} from "react-icons/fa";
import { Tooltip } from "@chakra-ui/react";
import { BsInfoCircle } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../../../../../ApiClient/GetApi";
import { PostApi } from "../../../../../ApiClient/PostApi";
import { Loader2 } from "../../../../loader/Loader";
import MessageBar from "../../../../messageBar/MessageBar";
import {
  error_toaster,
  info_toaster,
  success_toaster,
} from "../../../../toaster/Toaster";
import Prohibited from "./Prohibited";

import "react-loading-skeleton/dist/skeleton.css";
export default function PackageBar() {
  const navigate = useNavigate();
  const [modalLoader, setModalLoader] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setModalLoader(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const [repacking, setRepacking] = useState(false);
  const [quote, setQuote] = useState(false);
  const [calculate, setCalculate] = useState(false);

  const {
    isOpen: DimensionOpen,
    onOpen: DimensionOnOpen,
    onClose: DimensionOnClose,
  } = useDisclosure();

  const [invoice, setInvoice] = useState(false);
  const [productInfo, setProductInfo] = useState(false);

  const [prohibited, setProhibited] = useState(true);
  const showProduct = () => {
    setProductInfo(!productInfo);
    setCalculate(true);
    setOrderButton(true);
  };
  const setServiceFunction = (value) => {
    setService(value);
    setCalculate(true);
    setOrderButton(true);
  };

  const closeProhibited = () => {
    setProhibited(false);
  };
  const [xl] = useMediaQuery("(min-width: 1280px)");
  const [lg] = useMediaQuery("(min-width: 1024px)");
  const [md] = useMediaQuery("(min-width: 768px)");
  const [sm] = useMediaQuery("(min-width: 640px)");
  const [xs] = useMediaQuery("(min-width: 425px)");

  // API INTEGRATIONS

  const codes = useFetch("booking/get_hs_codes");
  const countries = useFetch("booking/get_country_price");

  const [insurance, setInsurance] = useState(false);
  const [orderButton, setOrderButton] = useState(true);
  const [service, setService] = useState("Full Services");

  const [companyId, setCompany] = useState("");
  const [freighPrice, setfreighPrice] = useState("");
  const [repackingPrice, setRepackingPrice] = useState(0);
  const [billablePrice, setbillablePrice] = useState(0);
  const [insuranceFee, setInsuranceFee] = useState(0);

  const [totalPrice, setTotalPrice] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [companyTax, setCompanyTax] = useState(0);
  const [loading, SetLoading] = useState(false);
  const [formValues, setFormValues] = useState([
    {
      weight: "",
      length: "",
      width: "",
      height: "",
      volumetricWeight: "",
      billableWeight: "",
      qty: "",
    },
  ]);
  const [productValues, setProductValues] = useState([
    {
      weight: "",
      quantity: "",
      price: "",
      description: "description",
      HsCode: "",
      OriginId: "",
      CountryId: "",
    },
  ]);
  const [vatTax, setVatTax] = useState("");
  const [importDuty, setImportDuty] = useState("");
  const [fee, setFee] = useState("");
  const [qty, setQty] = useState("");
  const [pqty, setPqty] = useState("");
  const [weight, setWeight] = useState("");
  const [pweight, setPWeight] = useState("");

  // ERRORS STATE
  const [weightError, setWeightError] = useState(false);
  const [lengthError, setLengthError] = useState(false);
  const [widthError, setWidthError] = useState(false);
  const [heightError, setHeightError] = useState(false);
  const [qtyError, setQtyError] = useState(false);

  const [pweightError, setpWeightError] = useState(false);
  const [desc, setDesc] = useState(false);
  const [count, setCount] = useState(false);
  const [code, setCode] = useState(false);
  const [pqtyError, setpQtyError] = useState(false);
  const [price, setPrice] = useState(false);

  const [companyShow, setCompanyShow] = useState(false);
  const [companyData, setCompanyData] = useState([]);

  var total = 0;
  var ptotal = 0;
  var w = 0;
  var pw = 0;
  useEffect(() => {
    for (var i = 0; i < formValues.length; i++) {
      total = total + parseInt(formValues[i].qty);
      w = w + parseInt(formValues[i].qty) * parseInt(formValues[i].weight);
    }
    setWeight(w);
    setQty(total);
    for (var i = 0; i < productValues.length; i++) {
      ptotal = ptotal + parseInt(productValues[i].quantity);
      pw =
        pw +
        parseInt(productValues[i].quantity) * parseInt(productValues[i].weight);
    }
    setPqty(ptotal);
    setPWeight(pw);
  }, [formValues, productValues]);

  let handleChange = (i, e) => {
    setCalculate(true);
    setOrderButton(true);
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
    setWeightError(false);
    setLengthError(false);
    setWidthError(false);
    setHeightError(false);
    setQtyError(false);
  };

  let addFormFields = () => {
    setCalculate(true);
    setOrderButton(true);
    setFormValues([
      ...formValues,
      {
        weight: "",
        qty: "",
        price: "",
        description: "",
        HsCode: "",
        OriginId: "",
        CountryId: "",
      },
    ]);
  };

  let removeFormFields = (i) => {
    setCalculate(true);
    setOrderButton(true);
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  //PRODUCT FORM VALUES

  let handleChangeProduct = async (i, e) => {
    setCalculate(true);
    setOrderButton(true);

    let newFormValuesProduct = [...productValues];
    newFormValuesProduct[i][e.target.name] = e.target.value;
    setProductValues(newFormValuesProduct);

    setDesc(false);
    setCode(false);
    setCount(false);
    setpWeightError(false);
    setpQtyError(false);
    setPrice(false);

    if (productValues[0].OriginId !== "" && productValues[0].CountryId !== "") {
      const res = await PostApi("booking/select_companies", {
        OriginId: productValues[0].OriginId,
        CountryId: productValues[0].CountryId,
      });
      setCompanyData(res?.data?.data);
      setCompanyShow(true);
    }
  };

  let addFormFieldsProduct = () => {
    setCalculate(true);
    setOrderButton(true);
    setProductValues([
      ...productValues,
      {
        weight: "",
        quantity: "",
        price: "",
        description: "",
        HsCode: "",
        OriginId: "",
        CountryId: "",
      },
    ]);
  };

  let removeFormFieldsProduct = (i) => {
    setOrderButton(true);
    setCalculate(true);
    let newFormValues = [...productValues];
    newFormValues.splice(i, 1);
    setProductValues(newFormValues);
  };

  const companyHandleChange = (event) => {
    let index = event.target.value;
    setCompany(index);
    setOrderButton(true);
  };

  const quoteHandleChange = () => {
    setQuote(true);
    if (quote === false) {
      DimensionOnOpen();
    }
  };

  const closeModal = () => {
    DimensionOnClose();
    setQuote(false);
  };
  const repackingOnchange = () => {
    setRepacking(!repacking);
    setCalculate(true);
    setOrderButton(true);
  };
  const handleKeyDown = (event) => {
    // Allow numeric keys, decimal point, and a few control keys
    if (
      !/^\d$/.test(event.key) &&
      event.key !== "." &&
      ![
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Enter",
      ].includes(event.key)
    ) {
      event.preventDefault();
    }
  };

  const sectionRef = useRef(null);

  // Function to scroll to the section
  const scrollToSection = () => {
    if (sectionRef.current) {
      // Scroll to the section element
      sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const calculate_price = async () => {
    const normalizeHsCode = (value) =>
      String(value || "")
        .trim()
        .toUpperCase();
    const validHsCodes = new Set(
      (codes?.data?.data || []).map((item) => normalizeHsCode(item?.HsCode))
    );

    if (service === "") {
      error_toaster("Please select a Service!");
      return false;
    }
    for (var i = 0; i < formValues.length; i++) {
      if (formValues[i].weight === "") {
        error_toaster("Package weight is required!");
        setWeightError(true);
        return false;
      } else if (formValues[i].weight === "0") {
        error_toaster("Package weight must be greater than 0!");
        return false;
      } else if (formValues[i].length === "") {
        setLengthError(true);
        error_toaster("Package length is required!");
        return false;
      } else if (formValues[i].length === "0") {
        error_toaster("Package length must be greater than 0!");
        return false;
      } else if (formValues[i].width === "") {
        setWidthError(true);
        error_toaster("Package width is required!");
        return false;
      } else if (formValues[i].width === "0") {
        error_toaster("Package width must be greater than 0!");
        return false;
      } else if (formValues[i].height === "") {
        setHeightError(true);
        error_toaster("Package height is required!");
        return false;
      } else if (formValues[i].height === "0") {
        error_toaster("Package height must be greater than 0!");
        return false;
      } else if (formValues[i].qty === "") {
        setQtyError(true);
        error_toaster("Package quantity is required!");
        return false;
      } else if (formValues[i].qty === "0") {
        error_toaster("Package quantity must be greater than 0!");
        return false;
      }
    }
    if (productInfo) {
      for (var i = 0; i < productValues.length; i++) {
        if (productValues[i].description === "") {
          setDesc(true);
          error_toaster("Description is required!");
          return false;
        } else if (productValues[i].HsCode === "") {
          setCode(true);
          error_toaster("HsCode is required!");
          return false;
        } else if (
          validHsCodes.size > 0 &&
          !validHsCodes.has(normalizeHsCode(productValues[i].HsCode))
        ) {
          setCode(true);
          error_toaster("HsCode is incorrect!");
          return false;
        } else if (productValues[0].CountryId === "") {
          setCount(true);
          error_toaster("Destination County is required!");
          return false;
        } else if (productValues[0].OriginId === "") {
          setCount(true);
          error_toaster("Origin County is required!");
          return false;
        } else if (productValues[i].weight === "") {
          setpWeightError(true);
          error_toaster("Product Weight is required!");
          return false;
        } else if (productValues[i].weight === "0") {
          error_toaster("Product Weight must be greater than 0!");
          return false;
        } else if (productValues[i].quantity === "") {
          setpQtyError(true);
          error_toaster("Product Quantity is required!");
          return false;
        } else if (productValues[i].quantity === "0") {
          error_toaster("Product Quantity must be greater than 0!");
          return false;
        } else if (productValues[i].price === "") {
          setPrice(true);
          error_toaster("Price is required!");
          return false;
        } else if (productValues[i].price === "0") {
          error_toaster("Price must be greater than 0!");
          return false;
        }
      }
    } else {
      error_toaster("Product info is required!");
      return false;
    }
    if (companyId === "") {
      error_toaster("Please select Logistic Company");
      return false;
    }
    if (qty > pqty) {
      error_toaster("Quantities are not Valid!");
      return false;
    }

    if (weight != pweight) {
      error_toaster("Weight are not Valid!");
      return false;
    } else {
      setOrderButton(false);
      setCalculate(false);
      SetLoading(true);
      const res = await PostApi("booking/calculate_price", {
        products: productValues,
        company: companyId,
        packages: formValues,
        repacking: repacking,
        service: service,
        product_insurance: insurance,
      });
      if (res?.data?.status === "1") {
        setInvoice(true);
        setVatTax(res.data.data.vatTax);
        setImportDuty(res.data.data.importDuty);
        setFee(res.data.data.customerClearanceFee);
        setTotalPrice(res.data.data.totalPrice);
        setfreighPrice(res.data.data.freighPrice);
        setTotalWeight(res.data.data.kg);
        setCompanyTax(res.data.data.companyTax);
        setRepackingPrice(res.data.data.repackingPrice);
        setbillablePrice(res.data.data.billablePrice);
        setInsuranceFee(res.data.data.insurance);
        SetLoading(false);
        setTimeout(() => {
          // Scroll to the bottom of the page after the delay
          window.scrollTo(0, document.body.scrollHeight);
        }, 100);
      } else {
        SetLoading(false);
        error_toaster(res?.data?.message || "Unable to calculate price");
      }
    }
  };

  const add_order = async (event) => {
    event.preventDefault();

    for (var i = 0; i < formValues.length; i++) {
      if (formValues[i].weight === "") {
        error_toaster("Weight is required!");
        return false;
      }
      if (formValues[i].height === "") {
        error_toaster("height is required!");
        return false;
      }
      if (formValues[i].qty === "") {
        error_toaster("Quantity is required!");
        return false;
      }
      if (formValues[i].width === "") {
        error_toaster("width is required!");
        return false;
      }
      if (formValues[i].length === "") {
        error_toaster("length is required!");
        return false;
      }
    }

    for (var i = 0; i < productValues.length; i++) {
      if (productValues[i].description === "") {
        error_toaster("Description is required!");
        return false;
      }
      if (productValues[i].weight === "") {
        error_toaster("Weight is required!");
        return false;
      }
      if (productValues[i].quantity === "") {
        error_toaster("Quantity is required!");
        return false;
      }
      if (productValues[i].HsCode === "") {
        error_toaster("HsCode is required!");
        return false;
      }
      if (productValues[0].OriginId === "") {
        error_toaster("Origin Country is required!");
        return false;
      }
      if (productValues[0].CountryId === "") {
        error_toaster("Destination Country is required!");
        return false;
      }
      if (productValues[i].price === "") {
        error_toaster("Price is required!");
        return false;
      }
    }
    if (companyId === "") {
      error_toaster("Please select atleast one Logistic Company!");
      return false;
    }

    if (qty > pqty) {
      error_toaster("Quantities is not Valid!");
      return false;
    }
    // if (weight > pweight || pweight > weight) {
    //   error_toaster("Weight is not Valid!");
    //   return false;
    // }
    SetLoading(true);
    const res = await PostApi("booking/add_order", {
      product_insurance: insurance,
      service: service,
      company: companyId,
      packages: formValues,
      products: productValues,
      repacking: repacking,
    });

    if (res?.data?.status === "1") {
      SetLoading(false);
      success_toaster(res.data.message);
      localStorage.setItem("orderId", res.data.data.booking.id);
      navigate("/supplier_details");
    } else if (res?.data?.message === "User not loggedIn!") {
      navigate("/login");
    } else {
      SetLoading(false);
      error_toaster(res?.data?.message || "Unable to place order");
    }
  };
  const inputStyle =
    "border-none bg-themeSecondary rounded p-3 placeholder:text-black placeholder:text-opacity-40 font-normal text-base focus:ring-0 w-full";
  const selectStyle =
    "w-full focus:outline-0 bg-themeSecondary px-4 py-3 rounded-md border-none font-normal text-base focus:outline-none cursor-pointer appearance-none";

  return (
    <>
      {/* <Modal
        isOpen={prohibited}
        onClose={closeProhibited}
        size={`${xl ? "5xl" : lg ? "4xl" : md ? "2xl" : sm ? "xl" : xs ? "sm" : "xs"
          }`}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            {modalLoader ? (
              <div className="relative">
                <Facebook height={200} className="my-20" />
              </div>
            ) : (
              <>
                <div
                  className="inline border-2 border-black border-opacity-60 px-1.5 float-right 
              rounded-fullest cursor-pointer sm:text-black"
                  onClick={closeProhibited}
                >
                  <FontAwesomeIcon
                    icon={faMultiply}
                    className="text-black text-opacity-60"
                  />
                </div>
                <h1 className="font-medium text-2xl text-themeBlue text-center mt-3">
                  Restricted Items
                </h1>
                <div className="grid md:grid-cols-8 sm:grid-cols-6 grid-cols-4 gap-x-5 gap-y-5 py-5 w-11/12 mx-auto">
                  <Prohibited image="prohibited1" text="Glass" />
                  <Prohibited image="prohibited2" text="Antiques" />
                  <Prohibited image="prohibited3" text="Tobacco" />
                  <Prohibited image="prohibited4" text="Explosive" />
                  <Prohibited image="prohibited5" text="Chemicals" />
                  <Prohibited image="prohibited6" text="Satellite" />
                  <Prohibited image="prohibited7" text="Cheques" />
                  <Prohibited image="prohibited8" text="Cash" />
                  <Prohibited image="prohibited9" text="Weapon" />
                  <Prohibited image="prohibited10" text="Gases" />
                  <Prohibited image="prohibited11" text="Alcohol" />
                  <Prohibited image="prohibited12" text="Drugs" />
                  <Prohibited image="prohibited13" text="Knives" />
                  <Prohibited image="prohibited14" text="Gambling" />
                  <Prohibited image="prohibited15" text="Liquid" />
                  <Prohibited image="prohibited16" text="Fire" />
                  <Prohibited image="prohibited17" text="Glass" />
                  <Prohibited image="prohibited18" text="Antiques" />
                  <Prohibited image="prohibited19" text="Tobacco" />
                  <Prohibited image="prohibited20" text="Explosive" />
                  <Prohibited image="prohibited21" text="Chemicals" />
                  <Prohibited image="prohibited22" text="Satellite" />
                  <Prohibited image="prohibited23" text="Cheques" />
                  <Prohibited image="prohibited24" text="Cash" />
                </div>
              </>
            )}

           
          </ModalBody>
        </ModalContent>
      </Modal> */}

      {codes?.data?.data?.length === 0 || loading ? (
        <div className="absolute left-[60%] top-[40%]">
          <Loader2 />
        </div>
      ) : (
        <div className="xl:col-span-9 lg:col-span-8 bg-themeSecondary py-6 sm:px-8 px-4 space-y-8">
          <div>
            <div className="space-y-4">
              <div className="[&>button>div]:border-none flex items-center gap-x-3">
                <label
                  htmlFor="insurance"
                  className="font-normal sm:text-xl text-lg text-black text-opacity-60"
                >
                  Do you want insurance of your products?
                </label>
                <ToggleSwitch
                  checked={insurance ? true : false}
                  onChange={() => setInsurance(!insurance)}
                  name="insurance"
                  id="insurance"
                />
                <div className="max-w-[24px]">
                  <Tooltip
                    label="Insurance provides protection against damage, loss, or theft during transit."
                    aria-label="A tooltip"
                    bg={"#124769"}
                  >
                    <div>
                      <BsInfoCircle
                        size={24}
                        className="cursor-pointer text-opacity-60 text-black"
                      />
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="[&>button>div]:border-none flex items-center gap-x-3">
                <label
                  htmlFor="repacking"
                  className="font-normal sm:text-xl text-lg text-black text-opacity-60"
                >
                  Do you want repacking and consolidation of your Shipment?
                </label>
                <ToggleSwitch
                  checked={repacking ? true : false}
                  onChange={() => repackingOnchange()}
                  name="repacking"
                  id="repacking"
                />
                <div className="max-w-[24px]">
                  <Tooltip
                    label="Repacking can optimize packaging, while consolidation combines multiple items into one shipment, potentially reducing costs."
                    aria-label="A tooltip"
                    bg={"#124769"}
                  >
                    <div>
                      <BsInfoCircle
                        size={24}
                        className="cursor-pointer text-opacity-60 text-black"
                      />
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="[&>button>div]:border-none flex items-center gap-x-3">
                <fieldset className="flex flex-col gap-4" id="radio">
                  <legend className="font-normal sm:text-xl text-lg text-black text-opacity-60 flex items-center gap-x-3">
                    Do you want to include Full services or Import services
                    only?
                    <div className="max-w-[24px]">
                      {service === "Full Services" ? (
                        <Tooltip
                          label="Our company manages all aspects of the shipping process, including shipping, customs clearance, and delivery."
                          aria-label="A tooltip"
                          bg={"#124769"}
                        >
                          <div>
                            <BsInfoCircle
                              size={24}
                              className="cursor-pointer text-opacity-60 text-black"
                            />
                          </div>
                        </Tooltip>
                      ) : (
                        <Tooltip
                          label="Users will handle customs clearance fee, import VAT and import duties and other aspects themselves, and Pacifrica will handle the shipping part."
                          aria-label="A tooltip"
                          bg={"#124769"}
                        >
                          <div>
                            <BsInfoCircle
                              size={24}
                              className="cursor-pointer text-opacity-60 text-black"
                            />
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  </legend>
                  <div className="flex items-center gap-x-6 mt-3 ml-0.5">
                    <div className="flex items-center gap-2">
                      <Radio
                        onChange={(e) => setServiceFunction(e.target.value)}
                        id="full_services"
                        name="services"
                        value="Full Services"
                        defaultChecked={
                          service === "Full Services" ? true : false
                        }
                        className="border-2 border-black border-opacity-60 checked:bg-black focus:ring-0 focus:outline-black"
                      />
                      <Label
                        htmlFor="full_services"
                        style={{ fontSize: "16px", fontWeight: "400" }}
                      >
                        Full Import service
                      </Label>
                    </div>
                    <div className="flex items-center gap-2">
                      <Radio
                        onChange={(e) => setServiceFunction(e.target.value)}
                        id="import_services"
                        name="services"
                        value="Shipping Service"
                        defaultChecked={
                          service === "Shipping Service" ? true : false
                        }
                        className="border-2 border-black border-opacity-60 checked:bg-black focus:ring-0 focus:outline-black"
                      />
                      <Label
                        htmlFor="import_services"
                        style={{ fontSize: "16px", fontWeight: "400" }}
                      >
                        Shipping Service only
                      </Label>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div className="[&>button>div]:border-none flex items-center gap-x-3">
                <label
                  htmlFor="quote"
                  className="font-normal sm:text-xl text-lg text-black text-opacity-60"
                >
                  Get a Quote
                </label>
                <BsInfoCircle
                  onClick={() => quoteHandleChange()}
                  name="quote"
                  id="quote"
                  size={24}
                  className="cursor-pointer text-black text-opacity-60"
                />
              </div>
              <div className="flex items-center gap-x-4">
                <div className="bg-white p-2 rounded-fullest">
                  <img
                    src="images/sendParcel/box.webp"
                    alt="box"
                    className="w-10"
                  />
                </div>
                <h1 className="font-medium text-2xl text-themeBlue">
                  Package(s) Details
                </h1>
              </div>
            </div>

            {/* <form onSubmit={add_order}> */}
            <section
              // key={index}
              className={`bg-white rounded-lg py-8 px-6 box-border space-y-8 my-4`}
            >
              {formValues.map((element, index) => (
                <React.Fragment key={`package-${index}`}>
                  <section className="md:grid grid-cols-12 gap-5 space-y-4 md:space-y-0  border-2 p-6 rounded-lg">
                    <div className="xl:col-span-3 md:col-span-4">
                      <label
                        htmlFor="vol_weight"
                        className="font-normal text-base"
                      >
                        Weight (Kg)
                      </label>
                      <input
                        onKeyDown={handleKeyDown}
                        value={element.weight || ""}
                        onChange={(e) => handleChange(index, e)}
                        type="text"
                        placeholder="Weight (Kg)"
                        name="weight"
                        className={inputStyle}
                      />
                      {weightError ? (
                        <span className="text-xs text-themeRed">
                          Weight is required!
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="xl:col-span-3 md:col-span-4">
                      <label
                        htmlFor="vol_weight"
                        className="font-normal text-base"
                      >
                        Length (cm)
                      </label>
                      <input
                        onKeyDown={handleKeyDown}
                        type="text"
                        placeholder="Length (cm)"
                        name="length"
                        value={element.length || ""}
                        onChange={(e) => handleChange(index, e)}
                        className={inputStyle}
                      />
                      {lengthError ? (
                        <span className="text-xs text-themeRed">
                          Length is required!
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="xl:col-span-3 md:col-span-4">
                      <label
                        htmlFor="vol_weight"
                        className="font-normal text-base"
                      >
                        Width (cm)
                      </label>
                      <input
                        onKeyDown={handleKeyDown}
                        type="text"
                        placeholder="Width (cm)"
                        name="width"
                        value={element.width || ""}
                        onChange={(e) => handleChange(index, e)}
                        className={inputStyle}
                      />
                      {widthError ? (
                        <span className="text-xs text-themeRed">
                          Width is required!
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="xl:col-span-3 md:col-span-4">
                      <label
                        htmlFor="vol_weight"
                        className="font-normal text-base"
                      >
                        Height (cm)
                      </label>
                      <input
                        onKeyDown={handleKeyDown}
                        type="text"
                        placeholder="Height (cm)"
                        name="height"
                        value={element.height || ""}
                        onChange={(e) => handleChange(index, e)}
                        className={inputStyle}
                      />
                      {heightError ? (
                        <span className="text-xs text-themeRed">
                          Height is required!
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="xl:col-span-4 md:col-span-4">
                      <label
                        htmlFor="quantity"
                        className="font-normal text-base"
                      >
                        Quantity
                      </label>
                      <input
                        type="text"
                        placeholder="Quantity"
                        name="qty"
                        value={element.qty || ""}
                        onChange={(e) => handleChange(index, e)}
                        id="qty"
                        className={inputStyle}
                        onKeyDown={handleKeyDown}
                      />
                      {qtyError ? (
                        <span className="text-xs text-themeRed">
                          Quantity is required!
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="xl:col-span-4 md:col-span-4">
                      <label
                        htmlFor="vol_weight"
                        className="font-normal text-base"
                      >
                        Volumetric Weight (kg)
                      </label>
                      <input
                        type="text"
                        placeholder="0"
                        readOnly
                        name="volumetricWeight"
                        value={
                          (element.height * element.width * element.length) /
                            5000 || ""
                        }
                        onChange={(e) => handleChange(index, e)}
                        id="vol_weight"
                        className={inputStyle}
                      />
                    </div>
                    <div className="xl:col-span-4 md:col-span-4">
                      <label
                        htmlFor="bill_weight"
                        className="font-normal text-base"
                      >
                        Billable Weight (kg)
                      </label>
                      <input
                        type="text"
                        readOnly
                        placeholder="0"
                        name="billableWeight"
                        value={
                          (element.height * element.width * element.length) /
                            5000 >
                          element.weight * element.qty
                            ? (element.height *
                                element.width *
                                element.length) /
                              5000
                            : element.weight * element.qty
                        }
                        onChange={(e) => handleChange(index, e)}
                        id="bill_weight"
                        className={inputStyle}
                      />
                    </div>

                    {index ? (
                      <div className="flex items-center justify-end md:col-span-1 sm:col-span-2">
                        <button
                          onClick={() => removeFormFields(index)}
                          className="bg-themeBlue p-2 rounded-fullest text-white hover:bg-themeRed"
                          // onClick={() => Remove_package(item)}
                        >
                          <FaTrash size="20px" />
                        </button>
                      </div>
                    ) : null}
                  </section>
                </React.Fragment>
              ))}

              <div className="button-section">
                <div className="col-span-12 flex justify-end">
                  <button
                    className="flex items-center gap-x-2 text-themeRed font-normal text-xl hover:text-black"
                    onClick={() => addFormFields()}
                  >
                    <FaPlus />
                    Add More
                  </button>
                </div>

                {/* <button className="button submit" type="submit">Submit</button> */}
              </div>
            </section>

            <div className="flex items-center gap-x-4 my-4">
              <div className="bg-white p-2 rounded-fullest">
                <img
                  src="images/sendParcel/box-forward.webp"
                  alt="box"
                  className="w-10"
                />
              </div>
              <h1 className="font-medium text-2xl text-themeBlue">
                Product Info
              </h1>
            </div>
            <section
              // key={index}
              className={`bg-white rounded-lg py-8 px-6 box-border space-y-8`}
            >
              {productInfo ? (
                <>
                  {productValues?.map((element, index) => (
                    <React.Fragment key={`product-${index}`}>
                      <section className="md:grid grid-cols-12 gap-5 space-y-4 md:space-y-0 border-2 p-6 rounded-lg">
                        <div className="xl:col-span-3 md:col-span-4">
                          <label
                            htmlFor="quantity"
                            className="font-normal text-base"
                          >
                            Description
                          </label>
                          <input
                            value={element.description || ""}
                            onChange={(e) => handleChangeProduct(index, e)}
                            type="text"
                            placeholder="Description"
                            name="description"
                            className={inputStyle}
                          />
                          {desc ? (
                            <span className="text-xs text-themeRed">
                              Description is required!
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="xl:col-span-3 md:col-span-4">
                          <label
                            htmlFor="quantity"
                            className="font-normal text-base"
                          >
                            HsCode
                          </label>
                          <input
                            onKeyDown={handleKeyDown}
                            value={element.HsCode || ""}
                            onChange={(e) => handleChangeProduct(index, e)}
                            type="text"
                            placeholder="8443.32.55.9"
                            name="HsCode"
                            className={inputStyle}
                          />
                          {/* <select
                          defaultValue={productValues[index].HsCode}
                            onChange={(e) => handleChangeProduct(index, e)}
                            name="HsCode"
                            className={selectStyle}
                          >
                            <option>HsCode</option>
                            {codes?.data?.data?.map((code) => (
                              <option value={code.HsCode}>{code.HsCode}</option>
                            ))}
                          </select> */}
                          {code ? (
                            <span className="text-xs text-themeRed">
                              HsCode is required!
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="xl:col-span-3 md:col-span-4">
                          <label
                            htmlFor="quantity"
                            className="font-normal text-base"
                          >
                            Origin
                          </label>
                          <select
                            disabled={productValues.length > 1}
                            onChange={(e) => handleChangeProduct(index, e)}
                            name="OriginId"
                            className={selectStyle}
                            value={productValues[0].OriginId}
                          >
                            <option value="">Country</option>
                            {countries?.data?.data?.map((country) => {
                              if (
                                country.name === "China" ||
                                country.name === "Hong Kong"
                              ) {
                                return (
                                  <option key={country.id} value={country.id}>
                                    {country.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </select>
                          {count ? (
                            <span className="text-xs text-themeRed">
                              Country is required!
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="xl:col-span-3 md:col-span-4">
                          <label
                            htmlFor="quantity"
                            className="font-normal text-base"
                          >
                            Destination
                          </label>
                          <select
                            onChange={(e) => handleChangeProduct(index, e)}
                            name="CountryId"
                            className={selectStyle}
                            disabled={productValues.length > 1}
                            value={productValues[0].CountryId}
                          >
                            <option value="">Country</option>
                            {countries?.data?.data?.map((country) => (
                              <option key={country.id} value={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </select>

                          {count ? (
                            <span className="text-xs text-themeRed">
                              Country is required!
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="xl:col-span-3 md:col-span-4">
                          <label
                            htmlFor="quantity"
                            className="font-normal text-base"
                          >
                            Weight (Kg)
                          </label>
                          <input
                            onKeyDown={handleKeyDown}
                            type="text"
                            placeholder="Weight (Kg)"
                            name="weight"
                            value={element.weight || ""}
                            onChange={(e) => handleChangeProduct(index, e)}
                            className={inputStyle}
                          />
                          {pweightError ? (
                            <span className="text-xs text-themeRed">
                              Weight is required!
                            </span>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="xl:col-span-3 md:col-span-4">
                          <label
                            htmlFor="quantity"
                            className="font-normal text-base"
                          >
                            Quantity
                          </label>
                          <input
                            onKeyDown={handleKeyDown}
                            type="text"
                            placeholder="Quantity"
                            name="quantity"
                            value={element.quantity || ""}
                            onChange={(e) => handleChangeProduct(index, e)}
                            id="quantity"
                            className={inputStyle}
                          />
                          {pqtyError ? (
                            <span className="text-xs text-themeRed">
                              Quantity is required!
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="xl:col-span-3 md:col-span-4">
                          <label
                            htmlFor="quantity"
                            className="font-normal text-base"
                          >
                            Price
                          </label>
                          <input
                            onKeyDown={handleKeyDown}
                            type="text"
                            placeholder="Price in $"
                            name="price"
                            value={element.price || ""}
                            onChange={(e) => handleChangeProduct(index, e)}
                            id="quantity"
                            className={inputStyle}
                          />
                          {price ? (
                            <span className="text-xs text-themeRed">
                              Price is required!
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        {index ? (
                          <div className="flex items-center justify-end md:col-span-1 sm:col-span-2">
                            <button
                              onClick={() => removeFormFieldsProduct(index)}
                              className="bg-themeBlue p-2 rounded-fullest text-white hover:bg-themeRed"
                            >
                              <FaTrash size="20px" />
                            </button>
                          </div>
                        ) : null}
                      </section>
                    </React.Fragment>
                  ))}
                  <div className="button-section">
                    <div className="col-span-12 flex justify-end">
                      <button
                        className="flex items-center gap-x-2 text-themeRed font-normal text-xl hover:text-black"
                        onClick={() => addFormFieldsProduct()}
                      >
                        <FaPlus />
                        Add More
                      </button>
                    </div>

                    {/* <button className="button submit" type="submit">Submit</button> */}
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-center py-12">
                    <button
                      onClick={showProduct}
                      className="py-3 px-12 border border-themeRed rounded-lg text-themeRed"
                    >
                      Add Product
                    </button>
                  </div>
                </>
              )}
            </section>

            <div className="flex gap-x-4">
              {formValues[0].qty === "" || productValues[0].quantity === "" ? (
                ""
              ) : (
                <>
                  {qty == pqty || qty < pqty ? (
                    <MessageBar
                      image="warning"
                      background="bg-themeGreenLight"
                      border="border-themeGreen"
                      imgback="bg-themeGreen"
                      text={`${pqty > qty ? `${pqty} > ${qty}` : ""} ${
                        pqty == qty ? `${pqty}/${qty}` : ""
                      } Woo-hoo! Your Product quantity is valid. `}
                    />
                  ) : (
                    <MessageBar
                      image="warning"
                      background="bg-themeYellowLight"
                      border="border-themeYellow"
                      imgback="bg-themeYellow"
                      text={`${
                        pqty > qty ? `` : `${pqty} < ${qty}`
                      } Your product quantity cannot be less than your package quantity.`}
                    />
                  )}
                </>
              )}
              {formValues[0].weight === "" || productValues[0].weight === "" ? (
                ""
              ) : (
                <>
                  {weight > pweight || pweight > weight ? (
                    <MessageBar
                      image="warning"
                      background="bg-themeYellowLight"
                      border="border-themeYellow"
                      imgback="bg-themeYellow"
                      text={`${weight}/${pweight} Your package and product weights do not match. `}
                    />
                  ) : (
                    <MessageBar
                      image="warning"
                      background="bg-themeGreenLight"
                      border="border-themeGreen"
                      imgback="bg-themeGreen"
                      text={`${weight}/${pweight} Woo-hoo! Your package and product weights match. `}
                    />
                  )}
                </>
              )}

              {/* <MessageBar
                image="warning"
                background="bg-themeYellowLight"
                border="border-themeYellow"
                imgback="bg-themeYellow"
                text={`Data Weight doesn't matched `}
              /> : <MessageBar
                image="warning"
                background="bg-themeGreenLight"
                border="border-themeGreen"
                imgback="bg-themeGreen"
                text={`Your Data Weight matched `}
              /> */}
            </div>
            <div className="[&>button>div]:border-none flex gap-x-3 mt-4">
              {companyShow ? (
                <fieldset className="flex flex-col gap-4" id="radio">
                  <legend className="font-normal sm:text-xl text-lg  text-black text-opacity-60 flex items-center gap-x-3">
                    Please select your logistic company
                    <div className="max-w-[24px]">
                      <Tooltip
                        label="Choose your logistics partner for seamless shipping solutions."
                        aria-label="A tooltip"
                        bg={"#124769"}
                      >
                        <div>
                          <BsInfoCircle
                            size={24}
                            className="cursor-pointer text-opacity-60 text-black"
                          />
                        </div>
                      </Tooltip>
                    </div>
                  </legend>

                  <div className="flex flex-wrap items-center gap-4 mt-4 ml-0.5">
                    {companyData.map((company) => (
                      <div
                        className={`px-4 w-[180px] py-6 rounded-lg bg-white border border-red-500`}
                        key={company.id}
                      >
                        <div className="flex items-center gap-2">
                          <input
                            checked={companyId == company.id ? true : false}
                            type="radio"
                            // name="company"
                            value={company.id}
                            onChange={companyHandleChange}
                          />
                          <label>{company?.Company?.name}</label>
                        </div>

                        <p className="text-sm text-themeRed text-center">
                          ($ {company.tax}) / Kg
                        </p>
                        <p className="text-sm text-themeRed text-center">
                          {" "}
                          {`Duration : ${company?.Company?.startDay}-${company?.Company?.endDay} Day`}
                        </p>
                      </div>
                    ))}
                  </div>
                </fieldset>
              ) : (
                ""
              )}
            </div>
          </div>

          <section
            className={`${
              invoice ? "block" : "hidden"
            } bg-white rounded-lg py-8 px-6 box-border space-y-8`}
            ref={sectionRef}
          >
            <div className="flex items-center gap-x-4">
              <div>
                <img
                  src="images/sendParcel/invoice.webp"
                  alt="box"
                  className="w-10"
                />
              </div>
              <h1 className="font-medium text-2xl text-themeBlue">
                Package Details
              </h1>
            </div>
            <div>
              <ul className="space-y-4">
                <li className="flex justify-end items-center gap-x-14">
                  <h5 className="font-medium text-base text-black text-opacity-40">
                    Freight ({totalWeight} Kg * ${companyTax})
                  </h5>
                  <h6 className="font-normal text-base">
                    ${freighPrice ?? "0.00"}
                  </h6>
                </li>
                {vatTax === 0 ? (
                  ""
                ) : (
                  <li className="flex justify-end items-center gap-x-14">
                    <h5 className="font-medium text-base text-black text-opacity-40">
                      Import VAT
                    </h5>
                    <h6 className="font-normal text-base">
                      ${vatTax ?? "0.00"}
                    </h6>
                  </li>
                )}
                {importDuty === 0 ? (
                  ""
                ) : (
                  <li className="flex justify-end items-center gap-x-14">
                    <h5 className="font-medium text-base text-black text-opacity-40">
                      Import Duties
                    </h5>
                    <h6 className="font-normal text-base">
                      ${importDuty ?? "0.00"}
                    </h6>
                  </li>
                )}
                {fee === 0 ? (
                  ""
                ) : (
                  <li className="flex justify-end items-center gap-x-14">
                    <h5 className="font-medium text-base text-black text-opacity-40">
                      Customs Clearance Fee
                    </h5>
                    <h6 className="font-normal text-base">${fee ?? "0.00"}</h6>
                  </li>
                )}
                <li className="flex justify-end items-center gap-x-14">
                  <h5 className="font-medium text-base text-black text-opacity-40">
                    Repacking Fee
                  </h5>
                  <h6 className="font-normal text-base">
                    ${repackingPrice ?? "0.00"}
                  </h6>
                </li>
                <li className="flex justify-end items-center gap-x-14">
                  <h5 className="font-medium text-base text-black text-opacity-40">
                    Insurance
                  </h5>
                  <h6 className="font-normal text-base">
                    ${insuranceFee ?? "0.00"}
                  </h6>
                </li>
                {/* <li className="flex justify-end items-center gap-x-14">
                    <h5 className="font-medium text-base text-black text-opacity-40">
                      Billable Price
                    </h5>
                    <h6 className="font-normal text-base">
                      ${billablePrice ?? "0.00"}
                    </h6>
                  </li> */}
                <li className="flex justify-end items-center gap-x-12">
                  <h1 className="font-medium text-4xl">${totalPrice}</h1>
                </li>
              </ul>

              <ul className="space-y-4 mt-3">
                <li className="font-medium text-base text-black text-opacity-40">
                  Instant quotes provided are estimates only and do not include
                  costs such as costs of purchasing goods and suppliers delivery
                  cost to the Pacifrica warehouse.
                </li>
                <li className="font-medium text-base text-black text-opacity-40">
                  The shipping cost is determined by the actual weight or
                  volumetric weight, whichever is greater. Volumetric weight of
                  package(s) = (length * width * height in (centimeters))/5000.
                </li>
                <li className="font-medium text-base text-black text-opacity-40">
                  Accuracy relies on your info and our terms.
                </li>
              </ul>
            </div>
          </section>

          <div className="flex justify-end gap-x-2">
            <button
              // onClick={showInvoice}
              onClick={calculate_price}
              className="bg-transparent text-themeBlue font-medium xl:text-xl lg:text-lg py-3 px-6 rounded-lg 
            border border-themeBlue gap-x-2 hover:bg-themeBlue hover:text-white sm:w-auto 
            w-full"
            >
              <span>{calculate ? "Calculate Price" : "Calculate Price"}</span>
            </button>
            {orderButton ? (
              ""
            ) : (
              <div>
                <Link
                  className="bg-themeBlue text-white font-medium xl:text-xl lg:text-lg py-3 px-6 rounded-lg 
          border border-themeBlue flex justify-center items-center gap-x-2 hover:bg-transparent hover:text-themeBlue 
          sm:w-auto w-full"
                  onClick={add_order}
                >
                  <span>Continue with Order</span>
                  <FaArrowRight />
                </Link>
              </div>
            )}
          </div>
          {/* <div className="[&>button>div]:border-none flex items-center gap-x-3">
              <fieldset className="flex flex-col gap-4" id="radio">
                <legend className="font-normal sm:text-xl text-lg text-black text-opacity-60 flex items-center gap-x-3">
                  Please select your logistic company
                  <div className="max-w-[24px]">
                    <FaRegQuestionCircle
                      size={24}
                      className="md:block hidden text-black text-opacity-60"
                    />
                  </div>
                </legend>
                <div className="flex items-center gap-x-6 mt-3 ml-0.5">
                  {
                    companies?.data?.data?.map((company) => (
                      <div className="  px-12 py-6 rounded-lg bg-white" key={company.id}>
                        <div className="flex items-center gap-2">
                          <Radio
                            id="dhl"
                            name="company"
                            value={company.id}
                            onChange={(e) => companyHandleChange(e)}
                            className="border-2 border-black checked:bg-black focus:ring-0 focus:outline-black"
                          />
                          <Label
                            htmlFor="dhl"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {company.name}
                          </Label>
                        </div>

                        <p className="text-sm text-themeRed">(R {company.tax})</p>
                      </div>
                    ))
                  }


                </div>
              </fieldset>
            </div> */}
          <div className="flex sm:flex-row flex-col sm:justify-end sm:items-center gap-x-4 gap-y-3"></div>
        </div>
      )}

      <Modal size="3xl" isOpen={DimensionOpen} onClose={closeModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <h1 className="text-2xl font-bold">Get a Quote</h1>
          </ModalHeader>

          <ModalCloseButton />
          {loading ? (
            <Loader2 />
          ) : (
            <>
              <ModalBody>
                <div className="space-y-4">
                  <h1 className="text-xl font-semibold">Packages</h1>
                  <p className="font-normal sm:text-xl text-lg text-black text-opacity-60">
                    A package is either a box, a flyer bag or a consignment
                    sleeve. Provide us with more details regarding the packaging
                    of your goods.
                  </p>
                  <Accordion>
                    <AccordionItem>
                      <h2>
                        <AccordionButton>
                          <Box
                            as="span"
                            flex="1"
                            textAlign="left"
                            className="font-semibold text-lg"
                          >
                            Don't have all your dimensions for your boxes?
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel
                        pb={4}
                        className="font-normal sm:text-xl text-lg text-black text-opacity-60"
                      >
                        The cost for shipping is based on the billable weight
                        (if you want to get technical, read more below). To
                        generate an estimated quote, capture the dimensions of
                        1cmx1cmx1cm as well as the accurate weight of the
                        package(s). When it arrives at the hub our team will
                        measure and confirm the dimensions of your package(s).
                        The only time that this won’t work is when you ship
                        products that are very light and volume heavy products,
                        like a big box of feathers!
                      </AccordionPanel>
                    </AccordionItem>

                    <AccordionItem>
                      <h2>
                        <AccordionButton>
                          <Box
                            as="span"
                            flex="1"
                            textAlign="left"
                            className="font-semibold text-lg"
                          >
                            What is Billable Weight?
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel
                        pb={4}
                        className="font-normal sm:text-xl text-lg text-black text-opacity-60"
                      >
                        This gets a little technical: Billable weight is the
                        greater of the actual weight and the volumetric weight.
                        Volumetric weight is a calculation based on the
                        dimensions of the package. Which is Length x Width x
                        Breadth / 5000.
                        <br />
                        <span className="text-themeRed font-semibold">
                          Example
                        </span>
                        : A box that is 30 kg and 100 cm x 100 cm x 100 cm will
                        have a volumetric weight of 100 x 100 x 100 / 5000 =
                        200.00 kg
                        <br />
                        The reason for this complexity is that some people might
                        ship feathers, which takes up a lot of space but does
                        not weigh a lot. In these cases, the volumetric weight
                        will be charged.
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>
                </div>
              </ModalBody>

              <ModalFooter>
                <div className="space-x-2">
                  <button
                    className="py-1 w-[100px] border border-themeBlue text-themeBlue rounded-lg"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                </div>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
